import * as React from 'react';
const SvgTiktok = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M19 8c-2.21 0-4-1.79-4-4h-2.5v11a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 2.5-2.5c.36 0 .69.08 1 .21V10.1A5.002 5.002 0 0 0 5 15c0 2.76 2.24 5 5 5s5-2.24 5-5V9.12a6.48 6.48 0 0 0 4 1.38z"
    />
  </svg>
);
export default SvgTiktok;
